<template>
  <div>
    <header>
      <b-container class="bv-example-row">
        <b-row>
          <b-col align="left" cols="3" sm="3" md="2">
            <router-link :to="{ name: `Home.${$i18n.i18next.language}` }"><img src="@/assets/images/logo-black.svg" width="80" alt="FINE.FIT" /></router-link>
          </b-col>
          <b-col align="right" cols="9" sm="9" md="10">
            <div class="d-none d-md-inline-block" v-if="authenticated">
              <div class="d-inline-block">

                <span v-if="1 ===2" class="d-inline-block d-md-none mr-2 user-name">{{ user.first_name }} {{ user.last_name }}</span>
                <span v-if="1 ===2" class="d-none d-md-inline-block mr-2 user-name" v-html="$t('account.signedInTitle', { name: `${user.first_name} ${user.last_name}` })"></span>

                <b-navbar class="user-navbar d-none d-md-inline-block pr-0 pl-0 align-middle">
                  <b-navbar-nav class="ml-auto mr-0">
                    <b-nav-item :to="{ name: `Home.${$i18n.i18next.language}` }" class="text-center search">
                      <i class="material-icons">
                        search
                      </i>
                      <div>{{ $t('searchTitle') }}</div>
                    </b-nav-item>
                    <b-nav-item :to="{ name: `AccountFeed.${$i18n.i18next.language}` }" class="text-center">
                      <i class="material-icons">
                        dashboard
                      </i>
                      <div>{{ $t('buttons.feed') }}</div>
                    </b-nav-item>
                    <b-nav-item :to="{ name: `AccountBookings.${$i18n.i18next.language}` }" class="text-center">
                      <i class="material-icons">
                        date_range
                      </i>
                      <div>{{ $t('buttons.bookings') }}</div>
                    </b-nav-item>
                    <b-nav-item v-if="user.role_id === 3" :to="{ name: `AccountMarketing.${$i18n.i18next.language}` }" class="text-center">
                      <i class="material-icons">
                        monetization_on
                      </i>
                      <div>{{ $t('buttons.marketing') }}</div>
                    </b-nav-item>
                    <b-nav-item href="javascript:void(0)" @click="openChat()" class="messages text-center">
                      <i class="material-icons">email</i>
                      <div>{{ $t('buttons.messages') }}</div>
                      <div v-if="unreadMessages > 0">
                        <span class="unread">{{ unreadMessages }}</span>
                        <i v-if="1 === 2" class="material-icons unread">error</i>
                      </div>
                    </b-nav-item>
                  </b-navbar-nav>
                </b-navbar>

                <b-dropdown v-if="authenticated" id="dropdown-1" class="d-none d-md-inline-block m-md-2">
                  <template v-slot:button-content>
                    <avatar class="d-inline-block align-top"
                            size="50px"
                            :userImage="user.image"
                            :userName="`${user.first_name} ${user.last_name}`"></avatar>
                  </template>
                  <b-dropdown-group id="dropdown-group-1">
                    <b-dropdown-header id="dropdown-header-user-info">
                      <div>{{ user.first_name }} {{ user.last_name }}</div>
                      <router-link v-if="user.role_id === 3" :to="{ name: `ProfessionalsSingle.${$i18n.i18next.language}`, params: { slug: user.slug } }" class="mt-1 d-block">{{ $t('buttons.viewProfile') }}</router-link>
                    </b-dropdown-header>
                  </b-dropdown-group>
                  <b-dropdown-group id="dropdown-group-1">
                    <b-dropdown-header id="dropdown-header-label-1" class="text-uppercase">
                      {{ $t('account.generalTitle') }}
                    </b-dropdown-header>
                    <b-dropdown-item :to="{ name: `Account.${$i18n.i18next.language}` }">{{ $t('account.basicInfoTitle') }}</b-dropdown-item>
                    <b-dropdown-item v-if="user.role_id === 3" :to="{ name: `AccountCertificates.${$i18n.i18next.language}` }">{{ $t('buttons.certificates') }}</b-dropdown-item>
                    <b-dropdown-item v-if="user.role_id === 3" :to="{ name: `AccountSocial.${$i18n.i18next.language}` }">{{ $t('account.socialTitle') }}</b-dropdown-item>
                  </b-dropdown-group>
                  <b-dropdown-group v-if="user.role_id === 3" id="dropdown-group-2">
                    <b-dropdown-header id="dropdown-header-label-2" class="text-uppercase">
                      {{ $t('account.offlineTitle') }}
                    </b-dropdown-header>
                    <b-dropdown-item :to="{ name: `AccountLocations.${$i18n.i18next.language}` }">{{ $t('account.locations.title') }}</b-dropdown-item>
                    <b-dropdown-item :to="{ name: `AccountServices.${$i18n.i18next.language}` }">{{ $t('account.servicesTitle') }}</b-dropdown-item>
                  </b-dropdown-group>
                  <b-dropdown-group v-if="user.role_id === 3" id="dropdown-group-3">
                    <b-dropdown-header id="dropdown-header-label-3" class="text-uppercase">
                      {{ $t('account.onlineTitle') }}
                    </b-dropdown-header>
                    <b-dropdown-item :to="{ name: `AccountServicesOnline.${$i18n.i18next.language}` }">{{ $t('account.servicesOnlineTitle') }}</b-dropdown-item>
                    <b-dropdown-item :to="{ name: `AccountOnlineMaterials.${$i18n.i18next.language}` }">{{ $t('account.onlineMaterialsTitle') }}</b-dropdown-item>
                  </b-dropdown-group>
                  <b-dropdown-group id="dropdown-group-4">
                    <b-dropdown-header id="dropdown-header-label-4" class="text-uppercase">
                      {{ $t('account.accountTitle') }}
                    </b-dropdown-header>
                    <b-dropdown-item :to="{ name: `AccountSettings.${$i18n.i18next.language}` }">{{ $t('buttons.settings') }}</b-dropdown-item>
                  </b-dropdown-group>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item-button @click.prevent="doSignOut">{{ $t('buttons.signOut') }}</b-dropdown-item-button>
                </b-dropdown>
              </div>
              <div v-if="1 === 2" class="d-inline-block align-top">
                <router-link :to="{ name: `Account.${$i18n.i18next.language}` }">
                  <b-btn class="account icon" variant="secondary" v-b-tooltip.hover title="My account">
                    <i class="material-icons">person</i>
                  </b-btn>
                </router-link>
                <a href="#messenger" class="btn messages icon" variant="secondary" v-b-tooltip.hover title="Messenger">
                  <i class="material-icons">email</i>
                  <div v-if="unreadMessages > 0">
                    <span class="unread">{{ unreadMessages }}</span>
                    <i v-if="1 === 2" class="material-icons unread">error</i>
                  </div>
                </a>
              </div>
              <div v-if="1 === 2" class="d-inline-block align-top">
                <b-btn class="d-none d-md-block" @click.prevent="doSignOut">{{ $t('buttons.signOut') }}</b-btn>
                <b-btn class="d-block d-md-none icon" @click.prevent="doSignOut"><i class="material-icons">exit_to_app</i></b-btn>
              </div>
            </div>
            <div class="d-none d-sm-inline-block align-top" v-else>
              <b-btn v-if="1 === 2" class="d-none d-sm-inline-block btn-outline tester" variant="primary" :to="{ name: `TestersLanding.${$i18n.i18next.language}` }">{{ $t('testers.ctaBtn') }}</b-btn>
              <b-btn class="sign-in" variant="primary" v-b-modal.signInModal>{{ $t('buttons.signIn') }}</b-btn>
              <b-btn class="sign-up" variant="primary" v-b-modal.signUpModal>{{ $t('buttons.signUp') }}</b-btn>
              <!--<router-link class="btn btn-primary" v-b-modal.signUpModal :to=" { name: 'SignUp' } ">{{ $t('buttons.signUp') }}</router-link>-->
            </div>
            <div id="languages" :class="[ authenticated ? 'd-none d-md-inline-block' : 'd-none d-sm-inline-block' ]" align="right">
              <div class="d-inline-block"><b-btn :class="{ active: isActiveLang('en') }" variant="secondary" @click="changeLanguage('en')">En</b-btn></div>
              <div class="d-inline-block"><b-btn :class="{ active: isActiveLang('fi') }" variant="secondary" @click="changeLanguage('fi')">Fi</b-btn></div>
            </div>

            <a href="#" @click.prevent="toggleMobileMenu()" class="hamburger d-inline-block" :class="[ authenticated ? 'd-md-none' : 'd-sm-none' ]">
              <span></span>
              <span></span>
              <span></span>
            </a>
          </b-col>
        </b-row>

        <div :class="{ show: mobileMenuShow }"
             @click.prevent="toggleMobileMenu()"
             class="overlay d-md-none"></div>

        <div v-if="authenticated" :class="{ show: authenticated && mobileMenuShow && !_.isEmpty(user) }" class="user-navbar-mobile d-md-none">
          <a href="#"
             @click.prevent="toggleMobileMenu()"
             class="btn-close">
            <i class="material-icons">
              clear
            </i>
          </a>
          <div class="mt-3 mb-3">
            <avatar class="d-inline-block align-top mr-2"
                    size="50px"
                    :userImage="user.image"
                    :userName="`${user.first_name} ${user.last_name}`"></avatar>
            <div class="d-inline-block">
              {{ user.first_name }} {{ user.last_name }}
              <router-link v-if="user.role_id === 3" @click.native="hideMobileMenu()" :to="{ name: `ProfessionalsSingle.${$i18n.i18next.language}`, params: { slug: user.slug } }" class="mt-1 d-block">{{ $t('buttons.viewProfile') }}</router-link>
            </div>
          </div>

          <div class="mx-auto align-middle">
            <div id="languages" class="align-middle mb-3">
              <div class="d-inline-block"><b-btn :class="{ active: isActiveLang('en') }" variant="secondary" @click="changeLanguage('en')">En</b-btn></div>
              <div class="d-inline-block"><b-btn :class="{ active: isActiveLang('fi') }" variant="secondary" @click="changeLanguage('fi')">Fi</b-btn></div>
            </div>
            <ul class="professional-pages">
              <li class="search">
                <router-link @click.native="hideMobileMenu()" :to="{ name: `Home.${$i18n.i18next.language}` }" class="text-center d-block nav-item">
                  <i class="material-icons">
                    search
                  </i>
                  <div>{{ $t('searchTitle') }}</div>
                </router-link>
              </li>
              <li>
                <router-link @click.native="hideMobileMenu()" :to="{ name: `AccountFeed.${$i18n.i18next.language}` }" class="text-center d-block nav-item">
                  <i class="material-icons">
                    dashboard
                  </i>
                  <div>{{ $t('buttons.feed') }}</div>
                </router-link>
              </li>
              <li>
                <router-link @click.native="hideMobileMenu()" :to="{ name: `AccountBookings.${$i18n.i18next.language}` }" class="text-center d-block nav-item">
                  <i class="material-icons">
                    date_range
                  </i>
                  <div>{{ $t('buttons.bookings') }}</div>
                </router-link>
              </li>
              <li v-if="user.role_id === 3">
                <router-link @click.native="hideMobileMenu()" :to="{ name: `AccountMarketing.${$i18n.i18next.language}` }" class="text-center d-block nav-item">
                  <i class="material-icons">
                    monetization_on
                  </i>
                  <div>{{ $t('buttons.marketing') }}</div>
                </router-link>
              </li>
              <li>
                <a href="javascript:void(0)" @click="openChat()" class="messages text-center d-block nav-item">
                  <i class="material-icons">email</i>
                  <div>{{ $t('buttons.messages') }}</div>
                  <div v-if="unreadMessages > 0">
                    <span class="unread">{{ unreadMessages }}</span>
                    <i v-if="1 === 2" class="material-icons unread">error</i>
                  </div>
                </a>
              </li>
            </ul>
            <hr />
            <ul class="d-block">
              <li class="mt-3 mb-3">
                <router-link @click.native="hideMobileMenu()" :to="{ name: `Account.${$i18n.i18next.language}` }">{{ $t('buttons.editAccount') }}</router-link>
              </li>
              <li>
                <a href="#" @click.prevent="doSignOut">{{ $t('buttons.signOut') }}</a>
              </li>
            </ul>
          </div>
        </div>

        <div v-else :class="{ show: mobileMenuShow }" class="user-navbar-mobile d-md-none">
          <a href="#"
             @click.prevent="toggleMobileMenu()"
             class="btn-close">
            <i class="material-icons">
              clear
            </i>
          </a>
          <div class="mx-auto align-middle">
            <div id="languages" class="align-middle mb-3">
              <div class="d-inline-block"><b-btn :class="{ active: isActiveLang('en') }" variant="secondary" @click="changeLanguage('en')">En</b-btn></div>
              <div class="d-inline-block"><b-btn :class="{ active: isActiveLang('fi') }" variant="secondary" @click="changeLanguage('fi')">Fi</b-btn></div>
            </div>
            <ul class="professional-pages" v-if="1 === 2">
              <li>
                <router-link @click.native="hideMobileMenu()" :to="{ name: `AccountFeed.${$i18n.i18next.language}` }" class="text-center d-block nav-item">
                  <i class="material-icons">
                    dashboard
                  </i>
                  <div>{{ $t('buttons.feed') }}</div>
                </router-link>
              </li>
              <li>
                <router-link @click.native="hideMobileMenu()" :to="{ name: `AccountBookings.${$i18n.i18next.language}` }" class="text-center d-block nav-item">
                  <i class="material-icons">
                    date_range
                  </i>
                  <div>{{ $t('buttons.bookings') }}</div>
                </router-link>
              </li>
              <li v-if="user.role_id === 3">
                <router-link @click.native="hideMobileMenu()" :to="{ name: `AccountMarketing.${$i18n.i18next.language}` }" class="text-center d-block nav-item">
                  <i class="material-icons">
                    monetization_on
                  </i>
                  <div>{{ $t('buttons.marketing') }}</div>
                </router-link>
              </li>
            </ul>
            <hr />
            <ul class="d-block">
              <li v-if="1 === 2" class="mt-3">
                <b-btn class="btn-outline white tester w-50" variant="primary" @click.native="hideMobileMenu()" :to="{ name: `TestersLanding.${$i18n.i18next.language}` }">{{ $t('testers.ctaBtn') }}</b-btn>
              </li>
              <li class="mt-3">
                <b-btn class="btn-white w-50" variant="primary" @click.prevent="mobileSignIn()">{{ $t('buttons.signIn') }}</b-btn>
              </li>
              <li class="mt-3">
                <b-btn class="btn-white w-50" variant="primary" @click.prevent="mobileSignUp()">{{ $t('buttons.signUp') }}</b-btn>
              </li>
            </ul>
          </div>
        </div>
      </b-container>
    </header>

    <b-alert variant="danger" v-if="Object.keys(errors).length > 0" show>
      {{ errors }}
    </b-alert>

  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import EventBus from '@/util/eventBus'

  export default {
    name: 'site-header',
    data () {
      return {
        errors: {},
        lang: this.$i18n.i18next.language,
        mobileMenuShow: false,
        isChatOpen: false
      }
    },
    computed: {
      ...mapGetters({
        user: 'account/user',
        authenticated: 'account/authenticated',
        userConversations: 'messenger/userConversations'
      }),
      unreadMessages: function () {
        if (!_.isEmpty(this.userConversations)) {
          let unread = 0

          _.forEach(this.userConversations, function(value, key) {
            if (value.unread === true) {
              ++unread
            }
          })
          return unread
        }
        return 0
      }
    },
    methods: {
      ...mapActions({
        signOut: 'auth/signOut',
        saveUserLang: 'account/saveUserLang',
        getServices: 'account/getServices',
        getSpecialities: 'account/getSpecialities'
      }),
      changeLanguage (lang) {
        this.lang = lang
        this.$i18n.i18next.changeLanguage(lang)

        if (this.authenticated) {
          let payload = {
            lang: lang
          }
          this.saveUserLang({payload: payload})
        }

        if (!_.isEmpty(this.$route)) {
          let routeName = this.$route.name
          routeName = routeName.split('.')[0]

          console.log(this.$route)

          let routeParams = {}
          if (!_.isEmpty(this.$route.params)) {
            routeParams = this.$route.params
          }

          // Disable language redirect for sign up page, because it breaks pre-defined form
          if (routeName !== 'SignUp') {
            this.$router.push({ name: `${routeName}.${lang}`, params: routeParams })
          }
        }
        this.hideMobileMenu()

        // Reload services and specialities in current language
        this.getServices({ context: this })
        this.getSpecialities({ context: this })
      },
      isActiveLang (value) {
        if (this.lang === value) {
          return true
        }
        return false
      },
      doSignOut: function () {
        this.hideMobileMenu()
        this.signOut()
      },
      scrollToBottom: function () {
        var messagesContainer = document.querySelector('.scroll')
        if (messagesContainer !== null) {
          messagesContainer.scrollTop = messagesContainer.scrollHeight
        }
      },
      toggleMobileMenu () {
        this.mobileMenuShow = !this.mobileMenuShow
      },
      hideMobileMenu () {
        this.mobileMenuShow = false
      },
      mobileSignIn () {
        this.$root.$emit('bv::show::modal', 'signInModal')
        this.hideMobileMenu()
      },
      mobileSignUp () {
        this.$root.$emit('bv::show::modal', 'signUpModal')
        this.hideMobileMenu()
      },
      openChat () {
        EventBus.$emit('openMessenger', 1)
        this.hideMobileMenu()
      },
      closeChat () {
        // this.isChatOpen = false
      }
    },
    mounted: function () {
      // If browser's language is Finnish, redirect to its page and language
      if (navigator.language === 'fi') {
        this.changeLanguage('fi')
      }
    }
  }
</script>

<style lang="scss" scoped>

  header {
    color: black;
    padding: 2rem 0;

    .container {
      @include media-breakpoint-down(sm) {
        max-width: 100%;
      }
    }

    a.hamburger {
      display: block;
      width: 30px;
      margin-top: 1rem;

      span {
        display: block;
        height: 3px;
        background: black;

        &:first-child {
          width: 90%;
          margin-bottom: 0.5rem;
        }

        &:nth-child(2) {
          width: 100%;
          margin-bottom: 0.5rem;
        }
        &:last-child {
          width: 70%
        }
      }
    }
    .overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.5);
      z-index: -1;
      opacity: 0;
      transition:all .2s ease;

      &.show {
        opacity: 1;
        z-index: 998;
      }
    }
    .user-navbar-mobile {
      position: fixed;
      right: -100%;
      top: 0;
      color: #777;
      width: 250px;
      height: 100%;
      background-color: #2c2b2b;
      z-index: 999;
      transition:all .5s ease;

      &.show {
        right: 0;
      }

      a.btn-close {
        position: absolute;
        left: -2rem;
        top: 0;
        display: block;
        font-size: 2rem;
        line-height: 2rem;
        padding: 0.2rem 0;
        text-decoration: none;
        background-color: #2c2b2b;

        i {
          color: white;
          font-size: 2rem;
          vertical-align: top;
        }
      }

      #languages {
        margin-left: 0;

        div {

          &:not(:first-child) {
            &:before {
              content: "";
              padding-right: 0.4rem;
            }
          }

          .btn-secondary {
            color: white;
            padding: 0.5rem;
            background: none !important;
            border: none;
            border-bottom: 2px solid transparent;

            &.active {
              border-bottom: 2px solid white;
            }
          }
        }
      }

      ul {
        list-style: none;
        margin: 0;
        padding: 0;

        &.professional-pages {
          li {
            display: inline-block;
            width: 42%;
            padding: 0;
            margin: 1rem 0;
            text-align: center;

            a {
              color: #777 !important;
              text-decoration: none;

              &.router-link-active {
                color: white !important;

                i {
                  color: #f1a444;
                }
              }

              &:hover {
                color: black;
              }
            }

            &.search {
              a {
                &.router-link-active {
                  color: #777 !important;
                  i {
                    color: #777;
                  }
                }
              }
            }
          }
        }
      }

      hr {
        border-color: #777;
      }
    }

    .user-navbar {
      color: black;
      /*margin-bottom: -2rem;
      border-top: 2px solid #ddd;*/
      background: transparent !important;

      li.nav-item {
        margin: 0 !important;
      }

      a {
        color: #777 !important;
        padding-top: 0;
        padding-bottom: 0;
        margin-left: 0.5rem;
        margin-right: 0.5rem;

        i {
          /*color: #f1a444;*/
        }

        &.router-link-active {
          color: black;

          i {
            color: #f1a444;
          }
        }

        &:hover {
          color: black;
        }
      }

      li.search {
        a {
          &.router-link-active {
            i {
              color: #777;
            }
          }
        }
      }

      /*ul.navbar-nav {*/
        /*-webkit-box-orient: horizontal !important;*/
        /*-webkit-box-direction: normal !important;*/
        /*-ms-flex-direction: row !important;*/
        /*flex-direction: row !important;*/
      /*}*/
    }

    .user-name {
      max-width: 250px;
      word-break: break-all;
    }

    .nav-item {
      position: relative;

      i {
        /*vertical-align: middle;*/
      }

      &.icon {
        color: $primary !important;
        margin-left: 0;
        margin-right: 0;
        padding-right: 0;
        padding-left: 0;

        &:hover {
          border-bottom: 0 !important;
        }
      }

      &.account {
        color: black !important;
      }

      .unread {
        position: absolute;
        right: 20%;
        top: -7px;
        color: white;
        border: 2px solid white;
        border-radius: 50%;
        width: 22px;
        height: 22px;
        background: #ff6910;
        text-align: center;
        margin: auto;
        font-size: 12px;
        font-weight: 500;
      }

      &.btn-secondary {
        color: black;
        border: none;
        border-radius: 0;
        background-color: transparent !important;

        &:hover {
          border-bottom: 1px solid black;
        }

        &:focus,
        &:active {
          color: black;
          outline: 0;
          box-shadow: none;
          background-color: transparent;
          border-color: transparent;
          box-shadow: none !important;
        }
      }

      &.sign-in {
        color: black !important;
        background-color: transparent !important;
      }
    }

    #languages {
      margin-left: 1rem;

      div {

        &:not(:first-child) {
          &:before {
            content: "|";
            padding-right: 0.4rem;
          }
        }

        .btn-secondary {
          color: black;
          padding: 0.375rem 0.2rem;
          background: none !important;
          border: none;
          border-bottom: 2px solid transparent;

          &.active {
            border-bottom: 2px solid black;
          }
        }
      }
    }
  }

  #messengerModal {
    .modal-dialog {
      max-width: 700px !important;
    }
  }

  .btn.tester-mobile {
    @include media-breakpoint-down(xs) {
      position: absolute;
      left: 50%;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
      top: 78px;
      z-index: 9;
    }
  }

  .btn.tester {
    box-sizing: border-box !important;
    -moz-box-sizing: border-box !important;
    -webkit-box-sizing: border-box !important;

    &.router-link-active {
      color: #f1a444 !important;
      border-color: #f1a444 !important;
    }
  }
</style>

<style lang="scss">
  .dropdown {
    button.dropdown-toggle {
      padding: 0 !important;
      padding-right: 4px !important;
      border: none !important;
      background-color: #f1a444 !important;

      &:after {
        margin-top: 1.45rem;
        vertical-align: middle;
      }
    }

    .dropdown-menu {
      color: white;
      border: none;
      border-radius: 0;
      background-color: #2c2b2b;

      .dropdown-header {
        color: rgba(255,255,255,0.6);
        display: block;
        padding: 0.5rem 1.5rem;
        margin-bottom: 0;
        font-size: 0.875rem;
        white-space: nowrap;
        background-color: rgba(255,255,255,0.2);

        &#dropdown-header-user-info {
          color: inherit;
          background-color: transparent;

          a {
            color: #f1a444 !important;
          }
        }
      }

      .dropdown-item {
        color: white;

        &:hover {
          background-color: rgba(255,255,255,0.2);
        }
      }

      a {
        color: white !important;
      }

      .dropdown-divider {
        border-top: 1px solid #595959;
      }
    }
  }
</style>
